module.exports = __webpack_public_path__ + "img/unrisd60-mobile.daeec8d6.png";